import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Select, MenuItem, FormControl, InputLabel,
    Grid, Typography, Box, Radio, RadioGroup, FormControlLabel,
    Divider
} from '@mui/material';
import api_service from '../../../network/api_callbacks';
import { generatePublicUrlForFileInAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket';
import _, { set } from "lodash";
import dayjs from 'dayjs';
import ProgressModal from '../../../utility/ProgressModal';
import Loader from '../../../utility/Loader';

const CheckAndShowKeys = Object.freeze({
    Collection: "collection",
    Points: "points",
    Count: "count",
    Pos: "pos",
    View: "view",
    Comment: "comment",
    Share: "share",
    Follower: "follower",
    Upload: "upload",
});

export default function ViewStatsDialog({ open, onClose, entityForViewStats }) {

    const [statsHistoryList, setStatsHistoryList] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        console.log('📘 ViewStatsDialog entityForViewStats:', entityForViewStats);
        if (entityForViewStats && statsHistoryList?.length === 0) {
            getStats();
        }
        return () => {
            setStatsHistoryList([]);
        }
    }, [entityForViewStats]);

    const getStats = async () => {
        setLoader(true);
        try {
            const response = await api_service.getStats();

            const exists = response?.some((item) => item?.entId === (entityForViewStats?.entity?._id || entityForViewStats?.entId));
            const matchedStats = response?.filter((item) => item?.entId === (entityForViewStats?.entity?._id || entityForViewStats?.entId));

            //console.log('📘 getStats entityForViewStats:', entityForViewStats);
            //console.log('📘 getStats response:', response);
            //console.log('📘 getStats exists:', exists);
            //console.log('📘 getStats matchedStats:', matchedStats);
            setStatsHistoryList(matchedStats?.[0]?.dates || []);
            setLoader(false);
        } catch (error) {
            console.error('❌ Failed to fetch getActiveStats:', error);
        }
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>{entityForViewStats?.entity?.displayName || entityForViewStats?.entityDetail?.displayName} {(entityForViewStats?.type || entityForViewStats?.entityDetail?.type) && `(${entityForViewStats?.type || entityForViewStats?.entityDetail?.type})`} Stats History</DialogTitle>
                <DialogContent dividers>
                    {loader ? (
                        <Loader />
                    ) : statsHistoryList?.length > 0 ? (
                        statsHistoryList.map((day, dIdx) => (
                            <Box key={dIdx} sx={{ mb: 3 }}>
                                {/* Date Header */}
                                <Typography variant="h6" sx={{ mb: 1 }}>
                                    {day?.date}
                                </Typography>
                                <Divider sx={{ mb: 1 }} />

                                {/* Records under date */}
                                {day?.data?.map((record, rIdx) => (
                                    <Box
                                        key={record?._id || rIdx}
                                        sx={{
                                            border: "1px solid #ccc",
                                            borderRadius: 2,
                                            p: 2,
                                            mb: 2,
                                            backgroundColor: "#fafafa",
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            {Object.entries(CheckAndShowKeys).map(([label, key]) => {
                                                if (record[key] === undefined || record[key] === null) return null;

                                                return (
                                                    <Grid item xs={6} sm={4} md={3} key={key}>
                                                        <Typography variant="caption" color="text.secondary">
                                                            {label}
                                                        </Typography>
                                                        <Typography variant="body2" fontWeight={500}>
                                                            {record[key]}
                                                        </Typography>
                                                    </Grid>
                                                );
                                            })}

                                            {record.updated_at && (
                                                <Grid item xs={12}>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Last Updated
                                                    </Typography>
                                                    <Typography variant="body2" fontWeight={500}>
                                                        {dayjs(record?.updated_at).format("HH:mm:ss")}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        ))
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No stats history available.
                        </Typography>
                    )}

                </DialogContent>

                <DialogActions>
                    <Button onClick={() => {
                        setStatsHistoryList([]);
                        onClose()
                    }} variant="contained">Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
